module.exports = __webpack_public_path__ + "img/educplay.7d5337fc.png";